// extracted by mini-css-extract-plugin
export default {"deal":"VendorDealsTable_deal__5-GWd"};